import {
  Injectable
} from '@angular/core';

import {
  StateDispatcher,
  StateOrchestrator
} from 'microedge-rxstate/dist';

import {
  ChecklistStateAction
} from './checklist-state-action.type';


export class ChecklistStateDispatcher extends StateDispatcher<ChecklistStateAction> {

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

export class ChecklistStateOrchestrator<T> extends StateOrchestrator<T, ChecklistStateAction> {

}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
